import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import IdfSurfingPackageExpansion from "app/Components/Block/IdfSurfingPackageExpansionBlock/IdfSurfingPackageExpansion";
import IdfSurfingPackageExpansionBlockData from "app/Models/Content/IdfSurfingPackageExpansionBlockData";

export default class IdfSurfingPackageExpansionBlock extends EpiComponent<IdfSurfingPackageExpansionBlockData> {

    constructor(props) {
        super(props);
    }

    public render(): ReactNode | ReactNodeArray | null {
        return <IdfSurfingPackageExpansion context={this.getContext()} iContent={this.props.data}/>
    }
}